/* eslint-disable no-console */
import { conf, t } from '../configService';

export const newsletterApiService = {
  callApi: (endpoint, body, method = 'GET') => {
    const apiKey = conf.newsletter.newsletter_api_key.split(':');

    const sendData = {
      method,
      headers: {
        'Content-Type': 'application/json',
        [apiKey[0]]: apiKey[1]
      }
    };
    if (body) {
      sendData.body = JSON.stringify(body);
    }
    return fetch(
      // Use heroku to bypass cors.
      // `https://infinite-basin-34160.herokuapp.com/${newsletterConfig.newsletter_api_url}${endpoint}`,
      `${conf.newsletter.newsletter_api_url}${endpoint}`,
      sendData
    );
  },
  getConsentMetadata: () => {
    return newsletterApiService.callApi(
      `client?configuration=${conf.newsletter.vendor_slug}`
    );
  },
  subscribe: data => {
    const thisData = data;
    const { email } = thisData;
    delete thisData.email;
    Object.keys(thisData).map(property => {
      if (thisData[property] === 1) {
        thisData[property] = true;
      }
      if (thisData[property] === '') {
        thisData[property] = false;
      }
      return null;
    });
    const body = {
      configuration: conf.newsletter.vendor_slug,
      email,
      data: thisData,
      opt_in: 'double'
    };
    return newsletterApiService.callApi(`subscribe`, body, 'POST');
  },
  consentManagement: token => {
    const userData = JSON.parse(atob(token));
    if (new Date().getTime() > new Date(userData.expires).getTime() * 1000) {
      console.log('Error: User data expired');
      return Promise.reject(new Error('User data expired'));
    }
    return newsletterApiService.callApi(
      `user/${userData.region}/${encodeURIComponent(userData.email)}`,
      userData.body,
      'PUT'
    );
    /* return newsletterApiService
      .callApi(`user/${userData.region}/${encodeURIComponent(userData.email)}`)
      .then(response => {
        if (response.status !== 200) {
          // eslint-disable-next-line no-console
          console.log('Error: ', response);
          return [];
        }
        return response.json();
      })
      .then(responseJson => {
        Object.keys(responseJson.data).forEach(key => {
          if (key in userData.body.data === false) {
            userData.body.data[key] = responseJson.data[key];
          }
        });
        return newsletterApiService.callApi(
          `user/${userData.region}/${encodeURIComponent(userData.email)}`,
          'PUT',
          userData.body
        );
      });
      */
  },
  sendConsentManagementConfirmation: async data => {
    const thisData = data;
    const { email, region, privacyPolicyDate } = data;
    const userData = await newsletterApiService.checkUser(email, region);
    if (userData.status === 200) {
      // const { privacyPolicyDate } = data;
      delete thisData.privacyPolicyDate;
      delete thisData.email;
      delete thisData.region;
      Object.keys(thisData).forEach(property => {
        if (thisData[property] === 1) {
          thisData[property] = true;
        }
        if (data[property] === '') {
          thisData[property] = false;
        }
      });

      const body = {
        privacyPolicyDate,
        data: thisData
      };

      const nextWeek = new Date();
      nextWeek.setDate(nextWeek.getDate() + 7);

      const token = btoa(
        JSON.stringify({
          email,
          region,
          body,
          expires: nextWeek.getTime() / 1000
        })
      );

      const salesForcePayload = {
        configuration: `fng-ng-globalsites-${conf.siteCountryCode}`,
        toAddress: email,
        template: 'PROD_NatGeoFox_CCT_MULTILAN',
        mergeVars: {
          Market: conf.siteCountryCode.toUpperCase(),
          LOB: 'NATGEO',
          STRING: t('Confirmation of consent changes'),
          name: email,
          url: `${document.location.origin}${document.location.pathname}?token=${token}`
        }
      };

      const payload = salesForcePayload;

      // Use a variable to ensure Promise is resolved.
      const postResponse = newsletterApiService
        .callApi('message', payload, 'POST')
        .then(response => {
          return response;
        });

      return postResponse;
    }
    return { error: 500 };
  },
  checkUser: async (email, region) => {
    let thisRegion = region;
    let userData = { status: 404 };
    if (!thisRegion) {
      thisRegion = await newsletterApiService
        .getConsentMetadata()
        .then(response => {
          if (response.status !== 200) {
            // eslint-disable-next-line no-console
            console.log('Error: ', response);
          }
          return response.json().consent.region.code;
        })
        .catch(e => {
          console.log('checkUser error', e);
        });
    }
    if (thisRegion) {
      userData = await newsletterApiService
        .callApi(`user/${thisRegion}/${encodeURI(email)}`)
        .then(response => {
          return response;
        });
    }
    return userData;
  }
};
